import React, { useState } from 'react';
import { CheckIcon, PlusIcon } from 'lucide-react';
import type { Product, VariantSelection } from '../../types/product';
import { useCart } from '../../contexts/CartContext';
import { formatPrice } from '../../utils/currency';
import { getProduct } from '../../utils/products';
interface Props {
  product: Product;
  selection: VariantSelection;
  mainPrice: number;
  mainImage: string;
}
export function FrequentlyBought({
  product,
  selection,
  mainPrice,
  mainImage
}: Props) {
  const {
    addItem
  } = useCart();
  const extras = (product.bundleIds ?? []).map(getProduct).filter((p): p is Product => !!p);
  const [checked, setChecked] = useState<string[]>(extras.map(p => p.id));
  if (extras.length === 0) return null;
  const selectedExtras = extras.filter(p => checked.includes(p.id));
  const total = mainPrice + selectedExtras.reduce((s, p) => s + p.price, 0);
  const addAll = () => {
    addItem(product, selection, 1, selectedExtras.length === 0);
    selectedExtras.forEach((p, i) => addItem(p, undefined, 1, i === selectedExtras.length - 1));
  };
  return <section aria-labelledby="fbt-heading" className="rounded-2xl bg-surface p-5 sm:p-6" data-id="element-357" data-mp="3n6yfarbfukj2">
      <h2 id="fbt-heading" className="text-lg font-bold tracking-tight text-ink" data-id="element-358" data-mp="3s6ubi4dw97o2">
        Vaak samen gekocht
      </h2>
      <div className="mt-5 flex flex-col gap-6 lg:flex-row lg:items-center" data-id="element-359" data-mp="10jc0coj8eyu">
        <div className="flex flex-1 items-center gap-3 overflow-x-auto" data-id="element-360" data-mp="2zi5hsqf644mc">
          <div className="w-28 shrink-0" data-id="element-361" data-mp="2zg2gha8kep2b">
            <img src={mainImage} alt="" className="aspect-square w-full rounded-lg bg-white object-cover" data-id="element-362" data-mp="34g721eoby9ze" />
            <p className="mt-2 line-clamp-2 text-xs font-medium text-ink" data-id="element-363" data-mp="39f1rgzgsywsh">Dit product</p>
            <p className="text-sm font-bold text-ink" data-id="element-364" data-mp="3e71lkba6yvh5">{formatPrice(mainPrice)}</p>
          </div>
          {extras.map(p => {
          const on = checked.includes(p.id);
          return <React.Fragment key={p.id} data-id="element-365" data-mp="2lpp8x8zl5cdi">
                <PlusIcon className="h-4 w-4 shrink-0 text-muted" aria-hidden="true" data-id="element-366" data-mp="2loe6bchvmanz" />
                <label className={`w-28 shrink-0 cursor-pointer transition-opacity duration-150 ${on ? '' : 'opacity-50'}`} data-id="element-367" data-mp="2do83oijaq55l">
                  <span className="relative block" data-id="element-368" data-mp="28ovj64fwda66">
                    <img src={p.image} alt="" className="aspect-square w-full rounded-lg bg-white object-cover" data-id="element-369" data-mp="2nekrcjmeqefy" />
                    <input type="checkbox" checked={on} onChange={() => setChecked(c => on ? c.filter(x => x !== p.id) : [...c, p.id])} className="peer sr-only" data-id="element-370" data-mp="2ih19zauexljs" />
                    <span className={`absolute right-2 top-2 flex h-5 w-5 items-center justify-center rounded border peer-focus-visible:ring-2 peer-focus-visible:ring-ink/40 ${on ? 'border-ink bg-ink' : 'border-ink/30 bg-white'}`} aria-hidden="true" data-id="element-371" data-mp="24q5xzpomaobz">
                      {on && <CheckIcon className="h-3 w-3 text-volt" strokeWidth={3} data-id="element-372" data-mp="3iozbidlzyf8g" />}
                    </span>
                  </span>
                  <span className="mt-2 line-clamp-2 block text-xs font-medium text-ink" data-id="element-373" data-mp="3nou7gvkmpv0d">{p.name}</span>
                  <span className="block text-sm font-bold text-ink" data-id="element-374" data-mp="39pclsp2mqxv8">{formatPrice(p.price)}</span>
                </label>
              </React.Fragment>;
        })}
        </div>
        <div className="shrink-0 border-t border-line pt-5 lg:w-56 lg:border-l lg:border-t-0 lg:pl-6 lg:pt-0" data-id="element-375" data-mp="5aumbrd3wzar">
          <p className="text-sm text-muted" data-id="element-376" data-mp="a7l3yj4k82ya">Totaal voor {1 + selectedExtras.length} producten</p>
          <p className="mt-1 text-2xl font-bold tracking-tight text-ink" data-id="element-377" data-mp="3sm43wv6fr6xp">{formatPrice(total)}</p>
          <button type="button" onClick={addAll} className="mt-3 h-11 w-full rounded-lg bg-ink text-sm font-semibold text-white transition-colors duration-150 hover:bg-ink-soft" data-id="element-378" data-mp="hs249u7z278">
            {1 + selectedExtras.length} in winkelwagen
          </button>
        </div>
      </div>
    </section>;
}